import { Set, Record as record } from 'immutable';

import { sum } from '../../helpers/Immutable';

const defaults = {
    tickets: new Set()
};

export default class RailcardTickets extends record(defaults) {

    add (ticket) {
        return this.set('tickets', this.tickets.add(ticket));
    }

    delete (ticket) {
        return this.set('tickets', this.tickets.delete(ticket));
    }

    concat (...values) {
        return this.set('tickets', this.tickets.concat(...values));
    }

    count () {
        return this.tickets.size;
    }

    get adults () {
        return sum(this.tickets, 'adults');
    }

    get children () {
        return sum(this.tickets, 'children');
    }

    get railcard () {
        return this.tickets.toList().getIn([0, 'railcard']);
    }

    get railcardCount () {
        const { railcard, adults, children } = this;
        if (!railcard) { return 0; }

        const { maxChildren, maxAdults } = railcard;
        const numRailcards = Math.max(
            (maxAdults > 0) ? Math.ceil(adults / maxAdults) : 0,
            (maxChildren > 0) ? Math.ceil(children / maxChildren) : 0
        );
        return numRailcards;
    }

    isValid () {
        const { railcard, railcardCount, adults, children } = this;
        if (railcardCount === 0) { return true; }

        const { minChildren, maxChildren, minAdults, maxAdults } = railcard;
        return (children >= minChildren * railcardCount) &&
                (children <= maxChildren * railcardCount) &&
                (adults >= minAdults * railcardCount) &&
                (adults <= maxAdults * railcardCount);
    }

}



// WEBPACK FOOTER //
// ./src/records/order/RailcardTickets.js